import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=04a02284&scoped=true&"
import script from "./OurServices.vue?vue&type=script&lang=ts&"
export * from "./OurServices.vue?vue&type=script&lang=ts&"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=04a02284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a02284",
  null
  
)

export default component.exports